import { useQuery } from "@tanstack/react-query";
import type { UserResponse } from "../../__generated__/api/wrenAPI.schemas";
import { getMeWebMeGet } from "../../__generated__/api/web/web";

export function useUser() {
  return useQuery<UserResponse>({
    queryKey: ["user-context"],
    queryFn: async () => {
      const response = await getMeWebMeGet();
      // customInstance throws on non-2xx, so response is always the success variant
      return response.data as UserResponse;
    },
  });
}
